import store from "store/store";
import { budgetBuilderSelectors } from "store/selectors";
import { save } from "utils/proxy";
import { API_BUDGET_BUILDER } from "globals/constants";

import { getPreparedPayload, prepareSetupPayload } from "./utils";
import { loadBudgetBuilder } from "./budgetBuilder";
import { notifyError } from "utils";

const options = { numRetries: 0, notifyUponError: true };

export const saveSetupData = async setupData => {
	const state = store.getState();
	const caseInstanceId = budgetBuilderSelectors.caseInstanceId(state);
	const payload = prepareSetupPayload(setupData, state);

	await save(`${API_BUDGET_BUILDER}/${caseInstanceId}/form`, payload, options);

	return loadBudgetBuilder();
};

export const saveBudgetBuilderForm = async () => {

	try {
		const state = store.getState();
		const caseInstanceId = budgetBuilderSelectors.caseInstanceId(state);
		// todo: check if getPreparedPayload is a duplicate of prepareSetupPayload
		const payload = getPreparedPayload(state);

		await save(`${API_BUDGET_BUILDER}/${caseInstanceId}/form`, payload, options);

		return loadBudgetBuilder();
	} catch (error) {
		notifyError(error.message, error);
	}
};
